import {
  ALL_POPUP_STATE,
  POPUP_OPEN_FIRST_STATE,
  POPUP_OPEN_STATE,
  POPUP_OPEN_SUB_STATE,
  POPUP_RESET_STATE,
  POPUP_STATE,
} from "../action/PopupAction";

const initialState = {
  popupData: [],

  allPopupState: false,
};

const popupReducer = (state = initialState, action) => {
  switch (action.type) {
    case POPUP_STATE:
      return {
        ...state,
        popupData: action.payload,
      };
    case ALL_POPUP_STATE:
      return {
        ...state,
        allPopupState: action.payload,
      };

    case POPUP_RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default popupReducer;
